// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyAdQGhulbQPg14P-Z2P8gUEc5f0DBTUjVI",
    authDomain: "imis-crm.firebaseapp.com",
    projectId: "imis-crm",
    storageBucket: "imis-crm.appspot.com",
    messagingSenderId: "395637297996",
    appId: "1:395637297996:web:3b2d15f4128d08ce31f5e9",
    measurementId: "G-CVQK2NGN82",
    vapidKey:"BA3UZyu8yifFV1Vbs4qY1X7RVlai-AzSA6HiEMRTwakV72PT7BJeaSg3y6OMirso7PlhxzNsvDsaFFhauHgwKnQ"
  },
  serviceWorkerScript: 'src/firebase-messaging-sw.js',
  // serviceRoot: 'http://crm.imis.ac.in/api',
  accountId:1000001,
  serviceRoot: '/api',
  authIp:"https://crm.imis.ac.in",
  baseUrl:"https://crm.imis.ac.in/login"
};

